
import {
  apiSupplierList,
  apiSupplierUpdate,
  apiSupplierSearch
} from '@/api/sync'
import { Component, Prop, Vue } from 'vue-property-decorator'
import lsPagination from '@/components/ls-pagination.vue'
import LsDialog from '@/components/ls-dialog.vue'
import { RequestPaging } from '@/utils/util'
import DatePicker from '@/components/date-picker.vue'
import { apiSelectUser } from '@/api/home'
@Component({
  components: {
    lsPagination,
    LsDialog,
    DatePicker
  }
})
export default class Supplier extends Vue {
  /** S Data **/

  apiSupplierList = apiSupplierList;

  pager: RequestPaging = new RequestPaging();
  updateForm: any = {
    is_open: ''
  };
  searchObj: any = {
    is_open: null,
    keyword: null,
    sid: null,
    status: null,
    sync_status: null
  };
  userLists = []//租户列表
  otherLists: any = {
    sync_status: { data: [] },
    // grade: { data: [] },
    statusbar: { data: [] },
    data_sync_type: { data: [] }
  };
  /** E Data **/

  /** S Methods **/
  // 获取搜索下拉数据
  getOtherMethodList(): void {
    apiSupplierSearch().then((res: any) => {
      this.otherLists = res
    })
  }
  // 搜索租户
  filterUser(userName: string = '') {
    this.getUserLists(userName);
  }

  // 获取租户列表
  getUserLists(keyword: string = '') {
    apiSelectUser({ keyword }).then((res: any) => {
      this.userLists = res.lists;
    });
  }
  // 获取商城列表
  getShopLists(page?: number): void {
     page && (this.pager.page = page);
    this.pager.request({
      callback: apiSupplierList,
      params: {
        ...this.searchObj,
      },
    });
  }
  updateDialog(row: any) {
    this.updateForm = row
    this.updateForm.is_open = row.is_open?.toString()
  }
  // 编辑
  async updateSupplier(item: any): Promise<void> {

    await apiSupplierUpdate({ id: item.id, is_open: item.is_open });
    this.$message.success('编辑成功');
    this.getShopLists();
  }

  // 重置搜索
  reset(): void {
    Object.keys(this.searchObj).map((key) => {
      this.$set(this.searchObj, key, "");
    });
    this.getShopLists(1);
  }

  /** E Methods **/

  /** S ods **/
  created() {
    this.getShopLists()
    this.getUserLists()
    this.getOtherMethodList()
  }
}
